export default __webpack_public_path__ + "assets/britishvirginislands-flag.png";